__turbopack_context__.v({
  "checkbox": "CollapsibleDemoContent-module__4BvT-a__checkbox",
  "code": "CollapsibleDemoContent-module__4BvT-a__code",
  "codeBlock": "CollapsibleDemoContent-module__4BvT-a__codeBlock",
  "codeSection": "CollapsibleDemoContent-module__4BvT-a__codeSection",
  "collapseLabel": "CollapsibleDemoContent-module__4BvT-a__collapseLabel",
  "container": "CollapsibleDemoContent-module__4BvT-a__container",
  "demoSection": "CollapsibleDemoContent-module__4BvT-a__demoSection",
  "expandLabel": "CollapsibleDemoContent-module__4BvT-a__expandLabel",
  "fileRefs": "CollapsibleDemoContent-module__4BvT-a__fileRefs",
  "header": "CollapsibleDemoContent-module__4BvT-a__header",
  "headerActions": "CollapsibleDemoContent-module__4BvT-a__headerActions",
  "headerContainer": "CollapsibleDemoContent-module__4BvT-a__headerContainer",
  "switchContainer": "CollapsibleDemoContent-module__4BvT-a__switchContainer",
  "tabContainer": "CollapsibleDemoContent-module__4BvT-a__tabContainer",
  "toggle": "CollapsibleDemoContent-module__4BvT-a__toggle",
});
